export const PARTNERS_CATEGORIES = 'categories'
export const SET_PARTNERS_CATEGORIES = PARTNERS_CATEGORIES + '/SET_PARTNERS_CATEGORIES'
export const SET_CURRENT_PARTNER_CATEGORY = PARTNERS_CATEGORIES + '/SET_CURRENT_PARTNER_CATEGORY'
export const RESET_CURRENT_CATEGORY = PARTNERS_CATEGORIES + '/RESET_CURRENT_CATEGORY'
export const SET_CATEGORIES_LOADED_FOR_LOCATION = PARTNERS_CATEGORIES + '/SET_CATEGORIES_LOADED_FOR_LOCATION'
